import { Observable } from 'rxjs'
import { BeneficiarySoaDetail } from '../models/view-soa-model'
import { SearchInsertModel } from '../models/search-soa-model'
import { ExportSOAModel } from '../models/export-soa-model'
export abstract class ViewSOAGateWay {
    abstract searchBSOAData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]>
    abstract searchPWBSOAData(searchsoadetail: SearchInsertModel): Observable<BeneficiarySoaDetail[]>

    abstract loadBSOAData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]>
    abstract loadPWBSOAData(searchsoadetail: BeneficiarySoaDetail): Observable<BeneficiarySoaDetail[]>

    abstract loadBSOADataSync(searchsoadetail: SearchInsertModel): BeneficiarySoaDetail[]

    abstract downloadPDF(pdfLink: BeneficiarySoaDetail): Observable<any>

    abstract getSOADataForExport(searchsoadetail: SearchInsertModel): Observable<ExportSOAModel[]>
    abstract getPWSOADataForExport(searchsoadetail: SearchInsertModel): Observable<ExportSOAModel[]>

    abstract streamPDF(selectedFileForDownload: BeneficiarySoaDetail): Observable<any>
}
